import { useMutation } from "@tanstack/react-query";
import { ResetPasswordPayload } from "./types";
import fetchData from "../fetcher";

export const useResetPassword = () => {
    const { mutateAsync, data, isPending, error, isError } = useMutation({
        mutationKey: ["resetPassword"],
        mutationFn: (body: ResetPasswordPayload) => fetchData<string, ResetPasswordPayload>("/iam/v4/auth/reset-password", { body, method: "POST" }),
    });

    return { ResetPassword: mutateAsync, data, isPending, error, isError };
}